import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Logo from './Logo';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '회사소개', href: isHome ? '#about' : '/#about' },
    { label: '기술소개', href: isHome ? '#technology' : '/#technology' },
    { label: '솔루션', href: isHome ? '#solutions' : '/#solutions' },
    { label: '특허', href: '/patents' },
    { label: 'R&D', href: '/rnd' },
    { label: 'IR', href: '/ir' },
    { label: '뉴스', href: isHome ? '#news' : '/#news' },
    { label: '문의', href: isHome ? '#contact' : '/#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-enerverze-bg/95 backdrop-blur-md border-b border-enerverze-border'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="/" className="flex items-center gap-3">
            <Logo className="h-8 w-8 md:h-10 md:w-10" />
            <span className="text-sm md:text-base font-semibold text-enerverze-text whitespace-nowrap">(주)에너버즈</span>
          </a>

          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`text-sm transition-colors whitespace-nowrap ${
                  location.pathname === item.href ||
                  (item.href.startsWith('/#') && location.pathname === '/' && location.hash === item.href.replace('/',''))
                    ? 'text-neon-cyan'
                    : 'text-enerverze-muted hover:text-neon-cyan'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 text-enerverze-text cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="메뉴"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-enerverze-bg/98 backdrop-blur-lg border-t border-enerverze-border">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="block text-base text-enerverze-muted hover:text-neon-cyan transition-colors py-2"
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}